"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import * as SelectPrimitive from "@radix-ui/react-select";
import Fuse from "fuse.js";
import { CheckIcon, ChevronDownIcon, ChevronUpIcon, SearchIcon } from "lucide-react";
import * as React from "react";
import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import type { BaseFormHelperProps } from "./types";
type SelectContentComponentProps = React.ComponentProps<typeof SelectPrimitive.Content> & {
  /** Rendered inside the content, above the scroll viewport (e.g. search). */
  header?: React.ReactNode;
};
interface SelectContentProps extends SelectContentComponentProps {}
interface SelectTriggerProps extends React.ComponentProps<typeof SelectPrimitive.Trigger> {
  size?: "sm" | "default";
}
type FormSelectOption = {
  label: string;
  value: string;
  icon?: React.ReactNode;
};
export type FormSelectOptions = FormSelectOption[] | Record<string, FormSelectOption[]>;
interface SelectProps extends React.ComponentProps<typeof SelectPrimitive.Root> {}
interface FormBaseSelectProps extends SelectProps {
  placeholder: string;
  options: FormSelectOptions;
  contentProps?: SelectContentProps;
  triggerProps?: SelectTriggerProps;
  searchable?: boolean;
  searchPlaceholder?: string;
}
interface FormSelectProps<TFieldValues extends FieldValues = FieldValues> extends BaseFormHelperProps<TFieldValues>, Omit<FormBaseSelectProps, "form"> {
  name: Path<TFieldValues>;
}
function Select(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <SelectPrimitive.Root data-slot="select" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function SelectGroup(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <SelectPrimitive.Group data-slot="select-group" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function SelectValue(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <SelectPrimitive.Value data-slot="select-value" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function SelectTrigger(t0) {
  const $ = _c(13);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("border-input data-[placeholder]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-10 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectPrimitive.Icon asChild={true}><ChevronDownIcon className="size-4 opacity-50" /></SelectPrimitive.Icon>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== props || $[10] !== size || $[11] !== t2) {
    t4 = <SelectPrimitive.Trigger className={t2} data-size={size} data-slot="select-trigger" {...props}>{children}{t3}</SelectPrimitive.Trigger>;
    $[8] = children;
    $[9] = props;
    $[10] = size;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function SelectContent(t0) {
  const $ = _c(22);
  let children;
  let className;
  let header;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      position: t1,
      header,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = header;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    header = $[3];
    props = $[4];
    t1 = $[5];
  }
  const position = t1 === undefined ? "popper" : t1;
  const t2 = position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1";
  let t3;
  if ($[6] !== className || $[7] !== t2) {
    t3 = cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md", t2, className);
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SelectScrollUpButton />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1";
  let t6;
  if ($[10] !== t5) {
    t6 = cn("p-1 [content-visibility:auto]", t5);
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== t6) {
    t7 = <SelectPrimitive.Viewport className={t6}>{children}</SelectPrimitive.Viewport>;
    $[12] = children;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SelectScrollDownButton />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== header || $[17] !== position || $[18] !== props || $[19] !== t3 || $[20] !== t7) {
    t9 = <SelectPrimitive.Portal><SelectPrimitive.Content className={t3} data-slot="select-content" position={position} {...props}>{header}{t4}{t7}{t8}</SelectPrimitive.Content></SelectPrimitive.Portal>;
    $[16] = header;
    $[17] = position;
    $[18] = props;
    $[19] = t3;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function SelectLabel(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-muted-foreground px-2 py-1.5 text-xs", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <SelectPrimitive.Label className={t1} data-slot="select-label" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function SelectItem(t0) {
  const $ = _c(13);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("focus:bg-accent focus:text-accent-foreground focus:[&_svg:not([class*='text-'])]:text-accent-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="absolute right-2 flex size-3.5 items-center justify-center"><SelectPrimitive.ItemIndicator><CheckIcon className="size-4" /></SelectPrimitive.ItemIndicator></span>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children) {
    t3 = <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>;
    $[7] = children;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t3) {
    t4 = <SelectPrimitive.Item className={t1} data-slot="select-item" {...props}>{t2}{t3}</SelectPrimitive.Item>;
    $[9] = props;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function SelectSeparator(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("bg-border pointer-events-none -mx-1 my-1 h-px", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <SelectPrimitive.Separator className={t1} data-slot="select-separator" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function SelectScrollUpButton(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex cursor-default items-center justify-center py-1", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronUpIcon className="size-4" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <SelectPrimitive.ScrollUpButton className={t1} data-slot="select-scroll-up-button" {...props}>{t2}</SelectPrimitive.ScrollUpButton>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function SelectScrollDownButton(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex cursor-default items-center justify-center py-1", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronDownIcon className="size-4" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <SelectPrimitive.ScrollDownButton className={t1} data-slot="select-scroll-down-button" {...props}>{t2}</SelectPrimitive.ScrollDownButton>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
const FORM_SELECT_FUSE_OPTIONS = {
  ignoreLocation: true,
  keys: ["label", "value"],
  threshold: 0.35
};

/** Fuse/filter runs after this delay so keystrokes stay responsive and the option list churn is reduced (helps Radix keep focus out of items while typing). */
const FORM_SELECT_SEARCH_DEBOUNCE_MS = 250;

/** Client-side fuzzy filter via Fuse.js; returns the same reference when `query` is empty. */
function filterFormSelectOptions(options: FormSelectOptions, isGroupedOptions: boolean, query: string): FormSelectOptions {
  const trimmed = query.trim();
  if (!trimmed) {
    return options;
  }
  if (isGroupedOptions) {
    const record = options as Record<string, FormSelectOption[]>;
    const next: Record<string, FormSelectOption[]> = {};
    for (const [group, opts] of Object.entries(record)) {
      const fuse = new Fuse(opts, FORM_SELECT_FUSE_OPTIONS);
      const matches = fuse.search(trimmed).map(result => result.item);
      if (matches.length > 0) {
        next[group] = matches;
      }
    }
    return next;
  }
  const fuse = new Fuse(options as FormSelectOption[], FORM_SELECT_FUSE_OPTIONS);
  return fuse.search(trimmed).map(result => result.item);
}
function normalizeFormSelectValue(value: unknown): string {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value);
}
function findFormSelectOptionByValue(options: FormSelectOptions, isGroupedOptions: boolean, selectedValue: string): {
  group?: string;
  option: FormSelectOption;
} | undefined {
  if (selectedValue === "") {
    return undefined;
  }
  if (isGroupedOptions) {
    const record = options as Record<string, FormSelectOption[]>;
    for (const [group, optionList] of Object.entries(record)) {
      const option = optionList.find(item => item.value === selectedValue);
      if (option) {
        return {
          group,
          option
        };
      }
    }
    return undefined;
  }
  const flat = options as FormSelectOption[];
  const option = flat.find(item => item.value === selectedValue);
  return option ? {
    option
  } : undefined;
}

/** Keeps the current selection mounted while searching so Radix does not clear `value`. */
function mergeSelectedOptionIntoFiltered(filtered: FormSelectOptions, fullOptions: FormSelectOptions, isGroupedOptions: boolean, selectedValue: unknown): FormSelectOptions {
  const stringValue = normalizeFormSelectValue(selectedValue);
  if (stringValue === "") {
    return filtered;
  }
  const found = findFormSelectOptionByValue(fullOptions, isGroupedOptions, stringValue);
  if (!found) {
    return filtered;
  }
  const {
    option,
    group
  } = found;
  if (isGroupedOptions) {
    const filteredRecord = {
      ...(filtered as Record<string, FormSelectOption[]>)
    };
    const groupKey = group ?? "";
    const currentList = filteredRecord[groupKey] ?? [];
    if (currentList.some(item => item.value === option.value)) {
      return filtered;
    }
    filteredRecord[groupKey] = [option, ...currentList];
    return filteredRecord;
  }
  const flatFiltered = filtered as FormSelectOption[];
  if (flatFiltered.some(item => item.value === option.value)) {
    return filtered;
  }
  return [option, ...flatFiltered];
}
export type FormSelectControlProps<TFieldValues extends FieldValues = FieldValues> = Omit<FormSelectProps<TFieldValues>, "form" | "name"> & {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
};
export function FormSelectControl(t0) {
  const $ = _c(89);
  let className;
  let description;
  let disabled;
  let field;
  let label;
  let options;
  let placeholder;
  let required;
  let selectProps;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      field,
      placeholder,
      options,
      label,
      description,
      className,
      contentProps: t1,
      triggerProps: t2,
      disabled,
      required,
      searchable: t3,
      searchPlaceholder: t4,
      ...selectProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = disabled;
    $[4] = field;
    $[5] = label;
    $[6] = options;
    $[7] = placeholder;
    $[8] = required;
    $[9] = selectProps;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    className = $[1];
    description = $[2];
    disabled = $[3];
    field = $[4];
    label = $[5];
    options = $[6];
    placeholder = $[7];
    required = $[8];
    selectProps = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
  }
  const contentProps = t1 === undefined ? {} : t1;
  let t5;
  if ($[14] !== t2) {
    t5 = t2 === undefined ? {} : t2;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const triggerProps = t5;
  const searchable = t3 === undefined ? false : t3;
  const searchPlaceholder = t4 === undefined ? "Search\u2026" : t4;
  let controlledOpen;
  let restSelectProps;
  let userOnOpenChange;
  if ($[16] !== selectProps) {
    ({
      open: controlledOpen,
      onOpenChange: userOnOpenChange,
      ...restSelectProps
    } = selectProps);
    $[16] = selectProps;
    $[17] = controlledOpen;
    $[18] = restSelectProps;
    $[19] = userOnOpenChange;
  } else {
    controlledOpen = $[17];
    restSelectProps = $[18];
    userOnOpenChange = $[19];
  }
  const [internalOpen, setInternalOpen] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState("");
  const searchInputRef = React.useRef(null);
  const restoreSearchFocusAfterFilterRef = React.useRef(false);
  let t6;
  let t7;
  if ($[20] !== searchQuery || $[21] !== searchable) {
    t6 = () => {
      if (!searchable) {
        return;
      }
      if (searchQuery.trim() === "") {
        setDebouncedSearchQuery("");
        return;
      }
      const timeoutId = window.setTimeout(() => {
        setDebouncedSearchQuery(searchQuery);
      }, FORM_SELECT_SEARCH_DEBOUNCE_MS);
      return () => window.clearTimeout(timeoutId);
    };
    t7 = [searchQuery, searchable];
    $[20] = searchQuery;
    $[21] = searchable;
    $[22] = t6;
    $[23] = t7;
  } else {
    t6 = $[22];
    t7 = $[23];
  }
  React.useEffect(t6, t7);
  let t8;
  if ($[24] !== searchable) {
    t8 = () => {
      if (!searchable) {
        return;
      }
      if (!restoreSearchFocusAfterFilterRef.current) {
        return;
      }
      restoreSearchFocusAfterFilterRef.current = false;
      const node = searchInputRef.current;
      if (node && document.activeElement !== node) {
        node.focus({
          preventScroll: true
        });
      }
    };
    $[24] = searchable;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== debouncedSearchQuery || $[27] !== searchable) {
    t9 = [debouncedSearchQuery, searchable];
    $[26] = debouncedSearchQuery;
    $[27] = searchable;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  React.useLayoutEffect(t8, t9);
  const isOpenControlled = controlledOpen !== undefined;
  let t10;
  if ($[29] !== isOpenControlled || $[30] !== searchable || $[31] !== userOnOpenChange) {
    t10 = next => {
      if (searchable) {
        if (!isOpenControlled) {
          setInternalOpen(next);
        }
        if (!next) {
          setSearchQuery("");
          setDebouncedSearchQuery("");
        }
      }
      userOnOpenChange?.(next);
    };
    $[29] = isOpenControlled;
    $[30] = searchable;
    $[31] = userOnOpenChange;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  const handleOpenChange = t10;
  const resolvedOpen = searchable ? isOpenControlled ? controlledOpen : internalOpen : controlledOpen;
  const isGroupedOptions = typeof options === "object" && !Array.isArray(options);
  let t11;
  bb0: {
    if (!searchable) {
      t11 = options;
      break bb0;
    }
    let t12;
    if ($[33] !== debouncedSearchQuery || $[34] !== field.value || $[35] !== isGroupedOptions || $[36] !== options) {
      const filtered = filterFormSelectOptions(options, isGroupedOptions, debouncedSearchQuery);
      t12 = mergeSelectedOptionIntoFiltered(filtered, options, isGroupedOptions, field.value);
      $[33] = debouncedSearchQuery;
      $[34] = field.value;
      $[35] = isGroupedOptions;
      $[36] = options;
      $[37] = t12;
    } else {
      t12 = $[37];
    }
    t11 = t12;
  }
  const optionsForRender = t11;
  let t12;
  if ($[38] !== isGroupedOptions || $[39] !== optionsForRender) {
    bb1: {
      const renderOptionContent = _temp;
      if (isGroupedOptions) {
        const grouped = optionsForRender as Record<string, FormSelectOption[]>;
        const entries = Object.entries(grouped);
        if (entries.length === 0) {
          let t13;
          if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
            t13 = <p className="text-muted-foreground px-2 py-6 text-center text-sm" role="status">No matching options</p>;
            $[41] = t13;
          } else {
            t13 = $[41];
          }
          t12 = t13;
          break bb1;
        }
        t12 = entries.map(t13 => {
          const [group, groupOptions] = t13;
          return <SelectGroup key={group}><SelectLabel>{group}</SelectLabel>{groupOptions.map(option_0 => <SelectItem key={option_0.value} value={option_0.value}>{renderOptionContent(option_0)}</SelectItem>)}</SelectGroup>;
        });
        break bb1;
      }
      const flat = optionsForRender as FormSelectOption[];
      if (flat.length === 0) {
        let t13;
        if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
          t13 = <p className="text-muted-foreground px-2 py-6 text-center text-sm" role="status">No matching options</p>;
          $[42] = t13;
        } else {
          t13 = $[42];
        }
        t12 = t13;
        break bb1;
      }
      let t13;
      if ($[43] !== flat) {
        let t14;
        if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
          t14 = option_1 => <SelectItem key={option_1.value} value={option_1.value}>{renderOptionContent(option_1)}</SelectItem>;
          $[45] = t14;
        } else {
          t14 = $[45];
        }
        t13 = flat.map(t14);
        $[43] = flat;
        $[44] = t13;
      } else {
        t13 = $[44];
      }
      t12 = t13;
    }
    $[38] = isGroupedOptions;
    $[39] = optionsForRender;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  const renderedOptions = t12;
  let t13;
  if ($[46] !== searchPlaceholder || $[47] !== searchQuery || $[48] !== searchable) {
    t13 = searchable ? <div className="bg-popover sticky top-0 z-10 border-b border-border/40 p-1" onKeyDownCapture={_temp2} onMouseDown={_temp3} onPointerDown={_temp4}><Input aria-label="Filter options" autoComplete="off" beforeIcon={<SearchIcon aria-hidden={true} />} className="h-8 shadow-none" onChange={event_2 => setSearchQuery(event_2.target.value)} onKeyDown={event_3 => {
        event_3.stopPropagation();
        restoreSearchFocusAfterFilterRef.current = true;
      }} onMouseDown={_temp5} onPointerDown={_temp6} placeholder={searchPlaceholder} ref={searchInputRef} type="search" value={searchQuery} wrapperClassName="w-full" /></div> : undefined;
    $[46] = searchPlaceholder;
    $[47] = searchQuery;
    $[48] = searchable;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  const searchHeader = t13;
  const {
    header: contentHeaderFromProps,
    ...restContentProps
  } = contentProps;
  let t14;
  if ($[50] !== field.value) {
    t14 = normalizeFormSelectValue(field.value);
    $[50] = field.value;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  const stringValue = t14;
  const T0 = FormItem;
  let t15;
  if ($[52] !== className) {
    t15 = cn(className);
    $[52] = className;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== label) {
    t16 = label && <FormLabel>{label}</FormLabel>;
    $[54] = label;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  const T1 = Select;
  const t17 = searchable ? handleOpenChange : userOnOpenChange;
  let t18;
  if ($[56] !== field) {
    t18 = next_0 => field.onChange(next_0 === "" ? undefined : next_0);
    $[56] = field;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  const t19 = searchable ? resolvedOpen : controlledOpen;
  let t20;
  if ($[58] !== placeholder) {
    t20 = <SelectValue placeholder={placeholder} />;
    $[58] = placeholder;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== t20 || $[61] !== triggerProps) {
    t21 = <FormControl><SelectTrigger className="w-full" {...triggerProps}>{t20}</SelectTrigger></FormControl>;
    $[60] = t20;
    $[61] = triggerProps;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  const T2 = SelectContent;
  const t22 = cn("max-h-[300px]", restContentProps?.className);
  const t23 = searchable ? searchHeader : contentHeaderFromProps;
  let t24;
  if ($[63] !== T2 || $[64] !== renderedOptions || $[65] !== restContentProps || $[66] !== t22 || $[67] !== t23) {
    t24 = <T2 {...restContentProps} className={t22} header={t23}>{renderedOptions}</T2>;
    $[63] = T2;
    $[64] = renderedOptions;
    $[65] = restContentProps;
    $[66] = t22;
    $[67] = t23;
    $[68] = t24;
  } else {
    t24 = $[68];
  }
  let t25;
  if ($[69] !== T1 || $[70] !== disabled || $[71] !== required || $[72] !== restSelectProps || $[73] !== stringValue || $[74] !== t17 || $[75] !== t18 || $[76] !== t19 || $[77] !== t21 || $[78] !== t24) {
    t25 = <T1 {...restSelectProps} disabled={disabled} onOpenChange={t17} onValueChange={t18} open={t19} required={required} value={stringValue}>{t21}{t24}</T1>;
    $[69] = T1;
    $[70] = disabled;
    $[71] = required;
    $[72] = restSelectProps;
    $[73] = stringValue;
    $[74] = t17;
    $[75] = t18;
    $[76] = t19;
    $[77] = t21;
    $[78] = t24;
    $[79] = t25;
  } else {
    t25 = $[79];
  }
  let t26;
  if ($[80] !== description) {
    t26 = description && <FormDescription>{description}</FormDescription>;
    $[80] = description;
    $[81] = t26;
  } else {
    t26 = $[81];
  }
  let t27;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <FormMessage />;
    $[82] = t27;
  } else {
    t27 = $[82];
  }
  let t28;
  if ($[83] !== T0 || $[84] !== t15 || $[85] !== t16 || $[86] !== t25 || $[87] !== t26) {
    t28 = <T0 className={t15}>{t16}{t25}{t26}{t27}</T0>;
    $[83] = T0;
    $[84] = t15;
    $[85] = t16;
    $[86] = t25;
    $[87] = t26;
    $[88] = t28;
  } else {
    t28 = $[88];
  }
  return t28;
}
function _temp6(event_5) {
  return event_5.stopPropagation();
}
function _temp5(event_4) {
  return event_4.stopPropagation();
}
function _temp4(event_1) {
  return event_1.stopPropagation();
}
function _temp3(event_0) {
  return event_0.stopPropagation();
}
function _temp2(event) {
  if (event.key === "Escape" || event.key === "Tab") {
    return;
  }
  event.stopPropagation();
}
function _temp(option) {
  return <>{option.icon}{option.label}</>;
}
function FormSelect(t0) {
  const $ = _c(10);
  let form;
  let name;
  let rest;
  if ($[0] !== t0) {
    ({
      form,
      name,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = form;
    $[2] = name;
    $[3] = rest;
  } else {
    form = $[1];
    name = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== rest) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <FormSelectControl {...rest} field={field} />;
    };
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== form.control || $[7] !== name || $[8] !== t1) {
    t2 = <FormField control={form.control} name={name} render={t1} />;
    $[6] = form.control;
    $[7] = name;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}

// New: Multi-select form helper (checkbox menu)
// API: options is a flat array, value bound to string[]
export interface FormMultiSelectOption {
  label: string;
  value: string;
}
export interface FormMultiSelectProps<TFieldValues extends FieldValues = FieldValues> extends BaseFormHelperProps<TFieldValues> {
  name: Path<TFieldValues>;
  label?: React.ReactNode;
  description?: string;
  placeholder: string;
  options: FormMultiSelectOption[];
  triggerProps?: React.ComponentProps<typeof SelectTrigger>;
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  maxVisibleSelectedItems?: number;
  searchable?: boolean;
  searchPlaceholder?: string;
}
export interface FormMultiSelectControlProps<TFieldValues extends FieldValues = FieldValues> {
  className?: string;
  description?: string;
  disabled?: boolean;
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  isLoading?: boolean;
  label?: React.ReactNode;
  loadingText?: string;
  maxVisibleSelectedItems?: number;
  options: FormMultiSelectOption[];
  placeholder: string;
  searchable?: boolean;
  searchPlaceholder?: string;
  triggerProps?: React.ComponentProps<typeof SelectTrigger>;
}
export function FormMultiSelectControl(t0) {
  const $ = _c(88);
  const {
    className,
    description,
    disabled,
    field,
    isLoading: t1,
    label,
    loadingText: t2,
    maxVisibleSelectedItems: t3,
    options,
    placeholder,
    searchable: t4,
    searchPlaceholder: t5,
    triggerProps
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const loadingText = t2 === undefined ? "Loading options..." : t2;
  const maxVisibleSelectedItems = t3 === undefined ? 3 : t3;
  const searchable = t4 === undefined ? false : t4;
  const searchPlaceholder = t5 === undefined ? "Search..." : t5;
  const triggerRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [contentWidth, setContentWidth] = React.useState(undefined);
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const update = () => {
        if (triggerRef.current) {
          setContentWidth(triggerRef.current.offsetWidth);
        }
      };
      update();
      const ro = new ResizeObserver(update);
      if (triggerRef.current) {
        ro.observe(triggerRef.current);
      }
      return () => ro.disconnect();
    };
    t7 = [];
    $[0] = t6;
    $[1] = t7;
  } else {
    t6 = $[0];
    t7 = $[1];
  }
  React.useEffect(t6, t7);
  let filteredOptions;
  let invisibleSelectedItemsText;
  let selectedCount;
  let selectedValues;
  let t8;
  if ($[2] !== field.value || $[3] !== maxVisibleSelectedItems || $[4] !== options || $[5] !== searchQuery || $[6] !== searchable) {
    selectedValues = Array.isArray(field.value) ? field.value : [];
    selectedCount = selectedValues.length;
    let t9;
    if ($[12] !== options || $[13] !== searchQuery || $[14] !== searchable) {
      t9 = searchable && searchQuery.trim() ? options.filter(opt => opt.label.toLowerCase().includes(searchQuery.trim().toLowerCase())) : options;
      $[12] = options;
      $[13] = searchQuery;
      $[14] = searchable;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    filteredOptions = t9;
    const visibleSelectedItems = selectedValues.slice(0, maxVisibleSelectedItems);
    const invisibleSelectedItemsCount = selectedValues.length - maxVisibleSelectedItems;
    invisibleSelectedItemsText = invisibleSelectedItemsCount > 0 ? `+${invisibleSelectedItemsCount} more` : "";
    let t10;
    if ($[16] !== options) {
      t10 = item => options.find(option => option.value === item)?.label;
      $[16] = options;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    t8 = visibleSelectedItems.map(t10).join(", ");
    $[2] = field.value;
    $[3] = maxVisibleSelectedItems;
    $[4] = options;
    $[5] = searchQuery;
    $[6] = searchable;
    $[7] = filteredOptions;
    $[8] = invisibleSelectedItemsText;
    $[9] = selectedCount;
    $[10] = selectedValues;
    $[11] = t8;
  } else {
    filteredOptions = $[7];
    invisibleSelectedItemsText = $[8];
    selectedCount = $[9];
    selectedValues = $[10];
    t8 = $[11];
  }
  const visibleSelectedItemsText = t8;
  const allSelected = options.length > 0 && selectedCount === options.length;
  let t9;
  if ($[18] !== field || $[19] !== selectedValues) {
    t9 = val => {
      const set = new Set(selectedValues);
      if (set.has(val)) {
        set.delete(val);
      } else {
        set.add(val);
      }
      field.onChange(Array.from(set));
    };
    $[18] = field;
    $[19] = selectedValues;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const toggleValue = t9;
  let t10;
  if ($[21] !== allSelected || $[22] !== field || $[23] !== options) {
    t10 = () => {
      if (allSelected) {
        field.onChange([]);
      } else {
        field.onChange(options.map(_temp7));
      }
    };
    $[21] = allSelected;
    $[22] = field;
    $[23] = options;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const toggleSelectAll = t10;
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = next => {
      setOpen(next);
      if (!next) {
        setSearchQuery("");
      }
    };
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const handleOpenChange = t11;
  let t12;
  if ($[26] !== className) {
    t12 = cn(className);
    $[26] = className;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== label) {
    t13 = label && <FormLabel>{label}</FormLabel>;
    $[28] = label;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = (triggerProps as {
    className?: string;
  })?.className;
  let t15;
  if ($[30] !== t14) {
    t15 = cn("border-input data-placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex min-w-0 w-full items-center gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-10 data-[size=sm]:h-8", t14);
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const t16 = (triggerProps as {
    size?: string;
  })?.size ?? "default";
  const t17 = disabled || isLoading;
  let t18;
  if ($[32] !== allSelected || $[33] !== invisibleSelectedItemsText || $[34] !== isLoading || $[35] !== loadingText || $[36] !== placeholder || $[37] !== selectedCount || $[38] !== visibleSelectedItemsText) {
    t18 = isLoading ? loadingText : selectedCount === 0 ? placeholder : allSelected ? "All selected" : <span className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden"><span className="min-w-0 flex-1 truncate text-left">{visibleSelectedItemsText}</span>{invisibleSelectedItemsText ? <span className="shrink-0 text-muted-foreground/90">{invisibleSelectedItemsText}</span> : null}</span>;
    $[32] = allSelected;
    $[33] = invisibleSelectedItemsText;
    $[34] = isLoading;
    $[35] = loadingText;
    $[36] = placeholder;
    $[37] = selectedCount;
    $[38] = visibleSelectedItemsText;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ChevronDownIcon className="ml-auto size-4 shrink-0 opacity-50" />;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t15 || $[42] !== t16 || $[43] !== t17 || $[44] !== t18) {
    t20 = <button className={t15} data-size={t16} data-slot="select-trigger" disabled={t17} ref={triggerRef} type="button">{t18}{t19}</button>;
    $[41] = t15;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== disabled || $[47] !== t20) {
    t21 = <DropdownMenu.Trigger asChild={true} disabled={disabled}>{t20}</DropdownMenu.Trigger>;
    $[46] = disabled;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  const t22 = searchable ? "flex max-h-[min(18rem,var(--radix-dropdown-menu-content-available-height,18rem))] flex-col overflow-hidden" : "max-h-72 overflow-y-auto";
  let t23;
  if ($[49] !== t22) {
    t23 = cn("bg-popover text-popover-foreground z-50 rounded-md border p-1 shadow-md", t22);
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== contentWidth) {
    t24 = {
      width: contentWidth
    };
    $[51] = contentWidth;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== searchPlaceholder || $[54] !== searchQuery || $[55] !== searchable) {
    t25 = searchable ? <div className="sticky top-0 z-10 shrink-0 border-b border-border/40 bg-popover p-1"><Input aria-label="Filter options" autoComplete="off" autoFocus={true} beforeIcon={<SearchIcon aria-hidden={true} />} className="h-8 shadow-none" onChange={event => setSearchQuery(event.target.value)} onKeyDown={_temp8} placeholder={searchPlaceholder} type="search" value={searchQuery} wrapperClassName="w-full" /></div> : null;
    $[53] = searchPlaceholder;
    $[54] = searchQuery;
    $[55] = searchable;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  const t26 = searchable && "min-h-0 overflow-y-auto";
  let t27;
  if ($[57] !== t26) {
    t27 = cn(t26);
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== allSelected || $[60] !== searchQuery || $[61] !== toggleSelectAll) {
    t28 = !searchQuery.trim() ? <><DropdownMenu.CheckboxItem checked={allSelected} className="relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 outline-hidden select-none focus:bg-accent focus:text-accent-foreground font-medium text-xs" onCheckedChange={toggleSelectAll} onSelect={_temp9}><span className="absolute right-2 flex size-3.5 items-center justify-center"><DropdownMenu.ItemIndicator><CheckIcon className="size-4" /></DropdownMenu.ItemIndicator></span>{allSelected ? "Deselect All" : "Select All"}</DropdownMenu.CheckboxItem><DropdownMenu.Separator className="bg-border -mx-1 my-1 h-px" /></> : null;
    $[59] = allSelected;
    $[60] = searchQuery;
    $[61] = toggleSelectAll;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== filteredOptions || $[64] !== selectedValues || $[65] !== toggleValue) {
    t29 = filteredOptions.length === 0 ? <p className="py-4 text-center text-xs text-muted-foreground">No options match your search.</p> : filteredOptions.map(option_0 => {
      const checked = selectedValues.includes(option_0.value);
      return <DropdownMenu.CheckboxItem checked={checked} className="relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground" key={option_0.value} onCheckedChange={() => toggleValue(option_0.value)} onSelect={_temp10}><span className="absolute right-2 flex size-3.5 items-center justify-center"><DropdownMenu.ItemIndicator><CheckIcon className="size-4" /></DropdownMenu.ItemIndicator></span><span className="min-w-0 wrap-break-word pr-6">{option_0.label}</span></DropdownMenu.CheckboxItem>;
    });
    $[63] = filteredOptions;
    $[64] = selectedValues;
    $[65] = toggleValue;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t27 || $[68] !== t28 || $[69] !== t29) {
    t30 = <div className={t27}>{t28}{t29}</div>;
    $[67] = t27;
    $[68] = t28;
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== t23 || $[72] !== t24 || $[73] !== t25 || $[74] !== t30) {
    t31 = <DropdownMenu.Portal><DropdownMenu.Content className={t23} style={t24}>{t25}{t30}</DropdownMenu.Content></DropdownMenu.Portal>;
    $[71] = t23;
    $[72] = t24;
    $[73] = t25;
    $[74] = t30;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== open || $[77] !== t21 || $[78] !== t31) {
    t32 = <FormControl><DropdownMenu.Root onOpenChange={handleOpenChange} open={open}>{t21}{t31}</DropdownMenu.Root></FormControl>;
    $[76] = open;
    $[77] = t21;
    $[78] = t31;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== description) {
    t33 = description ? <FormDescription>{description}</FormDescription> : null;
    $[80] = description;
    $[81] = t33;
  } else {
    t33 = $[81];
  }
  let t34;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <FormMessage />;
    $[82] = t34;
  } else {
    t34 = $[82];
  }
  let t35;
  if ($[83] !== t12 || $[84] !== t13 || $[85] !== t32 || $[86] !== t33) {
    t35 = <FormItem className={t12}>{t13}{t32}{t33}{t34}</FormItem>;
    $[83] = t12;
    $[84] = t13;
    $[85] = t32;
    $[86] = t33;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  return t35;
}
function _temp10(event_2) {
  return event_2.preventDefault();
}
function _temp9(event_1) {
  return event_1.preventDefault();
}
function _temp8(event_0) {
  return event_0.stopPropagation();
}
function _temp7(opt_0) {
  return opt_0.value;
}
export function FormMultiSelect(t0) {
  const $ = _c(17);
  const {
    form,
    name,
    label,
    description,
    placeholder,
    options,
    triggerProps,
    disabled,
    isLoading: t1,
    className,
    loadingText: t2,
    maxVisibleSelectedItems: t3,
    searchable: t4,
    searchPlaceholder: t5
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const loadingText = t2 === undefined ? "Loading options..." : t2;
  const maxVisibleSelectedItems = t3 === undefined ? 3 : t3;
  const searchable = t4 === undefined ? false : t4;
  const searchPlaceholder = t5 === undefined ? "Search..." : t5;
  let t6;
  if ($[0] !== className || $[1] !== description || $[2] !== disabled || $[3] !== isLoading || $[4] !== label || $[5] !== loadingText || $[6] !== maxVisibleSelectedItems || $[7] !== options || $[8] !== placeholder || $[9] !== searchPlaceholder || $[10] !== searchable || $[11] !== triggerProps) {
    t6 = t7 => {
      const {
        field
      } = t7;
      return <FormMultiSelectControl className={className} description={description} disabled={disabled} field={field} isLoading={isLoading} label={label} loadingText={loadingText} maxVisibleSelectedItems={maxVisibleSelectedItems} options={options} placeholder={placeholder} searchable={searchable} searchPlaceholder={searchPlaceholder} triggerProps={triggerProps} />;
    };
    $[0] = className;
    $[1] = description;
    $[2] = disabled;
    $[3] = isLoading;
    $[4] = label;
    $[5] = loadingText;
    $[6] = maxVisibleSelectedItems;
    $[7] = options;
    $[8] = placeholder;
    $[9] = searchPlaceholder;
    $[10] = searchable;
    $[11] = triggerProps;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== form.control || $[14] !== name || $[15] !== t6) {
    t7 = <FormField control={form.control} name={name} render={t6} />;
    $[13] = form.control;
    $[14] = name;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export { FormSelect, type FormSelectProps, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger, SelectValue };